import React, { Component } from "react";
import Switch from "react-switch";
import styles from "../common/Toggle.scss";
 
class Toggle extends Component {
 constructor(props) {
 super(props);
 this.handleChange = this.handleChange.bind(this);
 }
handleChange =checked =>{
    this.props.handleChange(checked);
    checked ? window.aUtils.sendAAEvent("ToggleOn",this.props.id) : window.aUtils.sendAAEvent("ToggleOff",this.props.id);

}


render() {
 return (
 
 <label htmlFor={this.props.id}>

 <Switch
 checked={this.props.isToggleOn}
 onChange={this.handleChange}
 handleDiameter={22}
 height={30}
 width={70}
 borderRadius={15}
 onColor="#64A000"
 offColor="#E9EAEE"
 disabled={this.props.isDisabled ? this.props.isDisabled : false}
 
uncheckedIcon={
    <div className={styles.Off}>Off</div>
   }
checkedIcon={<div className={styles.On}>On</div>
   }
 
 className="react-switch"
 id={this.props.id} 
 />
</label>
 
 );
 }
}
export default Toggle;
